import React, { useState } from "react"
import styled from "styled-components"

import { BagItemList } from "./BagItemList"

import { BsBag } from "react-icons/bs"
import { MdClose } from "react-icons/md"

const Bag = () => {
  const [showBag, setShowBag] = useState(false)

  let menuOverlay

  if (showBag) {
    menuOverlay = (
      <MenuOverlay
        onClick={() => {
          setShowBag(false)
        }}
      />
    )
  }

  return (
    <>
      <BagIcon onClick={() => setShowBag(!showBag)} />
      <BagMenu showBag={showBag}>
        <TitleContainer>
          <h1>Bag</h1>
          <BagClose onClick={() => setShowBag(!showBag)} />
        </TitleContainer>
        <BagItemList />
      </BagMenu>
      {menuOverlay}
    </>
  )
}

export default Bag

const BagIcon = styled(BsBag)`
  font-size: 1.5rem;
  cursor: pointer;
  height: 100%;

  @media screen and (min-width: 1000px) {
    position: fixed;
    right: 2.5px;
    z-index: 999;
    font-size: 2.2rem;
    height: 80px;
  }
`

const BagMenu = styled.div`
  position: fixed;
  height: 100%;
  width: 60%;
  max-width: 460px;
  background: #fff;
  z-index: 999;
  top: 0;

  right: ${props => (props.showBag ? "0" : "-60%")};
  transition: ${props => (props.showBag ? "500ms" : "300ms")};
`

const TitleContainer = styled.div`
  font-family: "julius sans one", serif;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const BagClose = styled(MdClose)`
  cursor: pointer;
  font-size: 2rem;
  height: 80px;
  /* position: absolute;
  right: 0; */
`

const MenuOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.25);
`
